interface VoiceAgentIconProps {
  size?: number;
  className?: string;
}

export default function VoiceAgentIcon({ size = 128, className = '' }: VoiceAgentIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="32"
        y="14"
        width="16"
        height="28"
        rx="8"
        stroke="currentColor"
        strokeWidth="2.2"
        fill="none"
      />
      <path
        d="M22 36c0 10 8 18 18 18s18-8 18-18"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        fill="none"
      />
      <path d="M40 54v10" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      <path d="M30 64h20" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      <path
        d="M14 30v8M18 26v16M22 28v12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.55"
      />
      <path
        d="M58 28v12M62 26v16M66 30v8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.55"
      />
    </svg>
  );
}
